import ko from 'knockout';
import $ from 'jquery';

/*
 * Enter binding
 */
ko.bindingHandlers.enter = {
  init(element, valueAccessor, allBindingsAccessor, data, bindingContext) {
    ko.bindingHandlers.event.init(element, () => ({
      keyup(keyUpData, event) {
        if (event.keyCode === 13) {
          valueAccessor().call(this, keyUpData, event);
        }
      },
    }), allBindingsAccessor, data, bindingContext);
  },
};

/*
 * Allow/disallow bindings to traverse down dom elements
 *   <div data-bind="allowBindings: false">
 *     <span>bindings dont apply here</span>
 */
ko.bindingHandlers.allowBindings = {
  init(elem, valueAccessor) {
    // Let bindings proceed as normal *only if* my value is false
    const shouldAllowBindings = ko.unwrap(valueAccessor());
    return { controlsDescendantBindings: !shouldAllowBindings };
  },
};

ko.bindingHandlers.toggleClick = {
  init(element, valueAccessor) {
    const value = valueAccessor();

    ko.utils.registerEventHandler(element, 'click', () => {
      value(!value());
    });
  },
};

ko.bindingHandlers.numeric = {
  init(element) {
    $(element).on('keydown', (event) => {
      // Allow: backspace, delete, tab, escape, and enter
      if (event.keyCode === 46
        || event.keyCode === 8
        || event.keyCode === 9
        || event.keyCode === 27
        || event.keyCode === 13
        // Allow: Ctrl without Alt
        || (event.ctrlKey === true && !event.altKey)
        // Allow: . ,
        || (event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 110)
        // Allow: home, end, left, right
        || (event.keyCode >= 35 && event.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
      }

      // Ensure that it is a number and stop the keypress
      if (event.shiftKey
        || ((event.keyCode < 48 || event.keyCode > 57)
        && (event.keyCode < 96 || event.keyCode > 105))) {
        event.preventDefault();
      }
    });
  },
};
